var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08579 12.1961L2.5 13.6103L4.06951 12.0408L4.07205 12.0421L5.74123 10.373L5.73909 10.3712L10.8662 5.24408L10.8679 5.24625L12.7012 3.41294L12.6989 3.4114L14.5208 1.58951L13.1066 0.175293L10.808 2.4739C9.9282 2.16678 8.98352 1.99994 8 1.99994C4.36364 1.99994 1.25818 4.28061 0 7.49994C0.515821 8.81978 1.34213 9.98185 2.38821 10.8937L1.08579 12.1961ZM4.56794 8.71396L9.23241 4.04948C8.84751 3.90955 8.43254 3.83328 8 3.83328C5.99273 3.83328 4.36364 5.47594 4.36364 7.49994C4.36364 7.92537 4.43561 8.33394 4.56794 8.71396Z",
    fill: "#ACACAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.9999C6.96429 12.9999 5.97165 12.8149 5.05249 12.4759L6.63088 10.8975C7.05353 11.071 7.51576 11.1666 8 11.1666C10.0073 11.1666 11.6364 9.52394 11.6364 7.49994C11.6364 7.02243 11.5457 6.56614 11.3808 6.14764L13.5098 4.01865C14.6042 4.94314 15.4675 6.13748 16 7.49994C14.7418 10.7193 11.6364 12.9999 8 12.9999Z",
    fill: "#ACACAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotEye);
export default __webpack_public_path__ + "static/media/IconNotEye.28a4c32533941addf4464448c87b9675.svg";
export { ForwardRef as ReactComponent };